module.exports = __webpack_public_path__ + "static/media/vehicle-with-notebook.94e1e265.svg";